import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { RideStatus } from '../../../types/ride';

interface StatusFilterProps {
  status?: RideStatus;
  onStatusChange: (status: RideStatus | undefined) => void;
}

const statusOptions = [
  { value: RideStatus.PENDING, label: 'Pending' },
  { value: RideStatus.ACCEPTED, label: 'Accepted' },
  { value: RideStatus.STARTED, label: 'Started' },
  { value: RideStatus.ARRIVED, label: 'Arrived' },
  { value: RideStatus.ENDED, label: 'Ended' },
  { value: RideStatus.CANCELED, label: 'Canceled' },
  { value: RideStatus.PAYMENT_SUCCEED, label: 'Payment Succeeded' },
  { value: RideStatus.PAYMENT_FAILED, label: 'Payment Failed' },
];

export default function StatusFilter({ status, onStatusChange }: StatusFilterProps) {
  const handleChange = (event: SelectChangeEvent<RideStatus | ''>) => {
    const value = event.target.value;
    onStatusChange(value === '' ? undefined : value as RideStatus);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="status-filter-label">Status</InputLabel>
      <Select
        labelId="status-filter-label"
        id="status-filter"
        value={status || ''}
        label="Status"
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>All</em>
        </MenuItem>
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
} 